// @flow
export { default } from './FakeQuoteCard';



// WEBPACK FOOTER //
// ./src/components/common/FakeQuoteCard/index.js